export default {
  SET_ASSIGNEES(state, data) {
    state.assignees = data;
  },
};
